// export const BASE_URL = 'https://phishing-tracker-core.herokuapp.com/';
export const projects = [
  {
    id: 1,
    name: 'TMS FPI',
    short: 'Web Application',
    client: 'Federal Polytechnic Ilaro',
    link: 'https://tmsfpi.com',
    dateCompleted: '31 Dec. 2022',
    project: ['/img/tmsfpi.PNG'],
    about:
      'Consectetur adipisicing elit. Placeat iusto ea, reiciendis harum debitis rerum quia amet vel corporis dolor officia perferendis fuga voluptate repudiandae facere cupiditate, natus eveniet officiis labore molestiae ut. Nisi doloremque facilis beatae natus numquam rem, modi quibusdam harum neque fugit explicabo repudiandae consectetur dolore. Eligendi tempore repellendus eveniet ipsum sunt est pariatur quaerat! Cupiditate, ducimus.',
  },
  {
    id: 2,
    name: 'Freshfruitcreamery',
    short: 'Web Application',
    client: 'Freshfruitcreamery',
    link: 'https://freshfruitcreamery.com',
    dateCompleted: '31 Jan. 2023',
    project: ['/img/freshfruitcreamery.png'],
    about:
      'Consectetur adipisicing elit. Placeat iusto ea, reiciendis harum debitis rerum quia amet vel corporis dolor officia perferendis fuga voluptate repudiandae facere cupiditate, natus eveniet officiis labore molestiae ut. Nisi doloremque facilis beatae natus numquam rem, modi quibusdam harum neque fugit explicabo repudiandae consectetur dolore. Eligendi tempore repellendus eveniet ipsum sunt est pariatur quaerat! Cupiditate, ducimus.',
  },
];
